import { useEffect, useLayoutEffect, useState } from 'react';

import {
  InvoicePaymentStatusService,
  PaymentStatusResponse,
} from '../InvoicePaymentStatusService';

const PAID_PAYMENT_INFO: PaymentStatusResponse = {
  isPaymented: true,
  paymentStatus: null,
  paidAmount: null,
  paymentTime: null,
  transactionId: null,
};

type UseInvoicePaymentStatusPollingOptions = {
  invoiceId?: string;
  enabled: boolean;
  isPaymented: boolean;
  intervalMs?: number;
};

export const useInvoicePaymentStatusPolling = ({
  invoiceId,
  enabled,
  isPaymented,
  intervalMs,
}: UseInvoicePaymentStatusPollingOptions) => {
  const [paymentInfo, setPaymentInfo] = useState<PaymentStatusResponse | null>(
    null,
  );

  useLayoutEffect(() => {
    setPaymentInfo(null);
  }, [invoiceId]);

  useEffect(() => {
    if (!enabled || !invoiceId) {
      setPaymentInfo(null);
      return;
    }

    if (isPaymented) {
      setPaymentInfo(PAID_PAYMENT_INFO);
      return;
    }

    return InvoicePaymentStatusService.startPolling({
      invoiceId,
      intervalMs,
      onUpdate: setPaymentInfo,
    });
  }, [enabled, invoiceId, isPaymented, intervalMs]);

  return paymentInfo;
};
